import { observer } from 'mobx-react-lite';
import { FC } from 'react';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';

import { useCompactViewCalendarPresenter } from './CompactViewCalendar.presenter';

export const CompactViewCalendar: FC = observer(() => {
  useCompactViewCalendarPresenter();

  return null;
});
